<ngx-ui-loader></ngx-ui-loader>
<section>
    <div class="tab-content pt-5 pb-5" style="display: block;">
        <div class="container mb-5">
            <header>
                <h3 class="header-title">{{taxConsentStep1 ? language.tax_header : language.tax_not_consent_header}}</h3>
            </header>
            <div class="px-0 col-12">
                <div *ngIf="taxConsentStep1" class="card-body">
                    <!-- <div class="row">
                        <div class="col-md-8 col-sm-12 mr-2">
                            <div class="row"><h4>{{language.tax_select_year}}</h4>
                            </div>                            
                        </div>
                        <div class="col-md col-sm-12" style="background-color: #395e77; height: 120px;">
                            <div class="row p-3 justify-content-center">
                                <label style="font-size: 1.3rem; color: white;" for="yearSelect">{{language.tax_dropdown_header}}</label>
                                <select class="form-control" id="yearSelect" [(ngModel)]="taxYear" (change)="selectTaxYear($event.target.value)">                                                
                                    <option *ngFor="let yyyy of selectYear" [value]="yyyy">{{yyyy}}</option>
                                </select>
                                <label class="pt-2" style="font-size: 1.3rem; color: white;">{{language.tax_dropdown_footer}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-3 pb-3" style="font-size: 1rem;">
                        <div class="col">
                            <div class="row">{{language.tax_remark}}</div>
                            <div class="row pt-1">{{language.tax_remark1}}</div>
                            <div class="row pt-1">{{language.tax_remark2}}</div>
                            <div class="row pt-1">{{language.tax_remark3}}</div>
                        </div>
                    </div> -->
                    <div class="card row p4">
                        <div class="row justify-content-md-center">
                            <div class="col-md-8 col-sm-8">                               
                                <div class="row justify-content-md-center pt-4">
                                    <div class="row">
                                        <div class="form-check m-2 pl-5 pr-5">
                                            <input class="form-check-input" type="radio" name="gridRadios" id="consentYes" value="true" [checked]="isAcceptConsent === true" (change)="onChangeTaxConsent(true)">
                                            <label class="form-check-label line-height-1_2" for="consentYes" [innerHTML]="language.tax_given"></label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-check m-2 pl-5 pr-5">
                                            <input class="form-check-input" type="radio" name="gridRadios" id="consentNo" value="false" [checked]="isAcceptConsent === false" (change)="onChangeTaxConsent(false)">
                                            <label class="form-check-label line-height-1_2" for="consentNo" [innerHTML]="language.tax_not_given"></label>
                                        </div>
                                    </div>
                                    <div class="row pl-5 pr-5 pt-3" style="font-size: 0.8rem;">
                                        <p class="row">{{language.tax_remark}}</p>
                                        <p class="line-height-1_2" [innerHTML]="language.tax_remark1"></p>
                                        <p class="line-height-1_2" [innerHTML]="language.tax_remark2"></p>
                                        <p class="line-height-1_2" [innerHTML]="language.tax_remark3"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <button class="btn text-center m-4 btn-primary btn-md col-lg-3 col-md-3 col-sm-12"
                                (click)="checkTaxConsent()">{{language.tax_submit}}</button>
                        </div>
                    </div>                                
                </div>
                <div *ngIf="taxConsentStep2" class="card p-4">
                    <div class="row justify-content-center">
                        <div class="col-8">
                            <div class="row">
                                <p class="indent line-height-1_3">{{language.tax_not_consent}} {{language.tax_not_consent2}}</p>
                            </div>
                            <!-- <div class="row text-center">
                                <p>{{language.tax_not_consent2}}</p>
                            </div> -->
                        </div>
                    </div>
                    <div class="row justify-content-center pt-4">
                        <button class="btn text-center m-1 btn-primary btn-md col-lg-3 col-md-3 col-sm-12"
                            (click)="sendTaxConsentData()">{{language.tax_confirm}}</button>
                        <button class="btn text-center m-1 btn-primary btn-md col-lg-3 col-md-3 col-sm-12"
                            (click)="gobackTaxConsent()">{{language.tax_cancel}}</button>
                    </div>
                </div>
                <div *ngIf="taxConsentStep3" class="card p-4">
                    <div class="row justify-content-center">
                        <div class="col-8">
                            <div class="row">
                                <p class="indent line-height-1_3">{{isAcceptConsent ? language.tax_submit_consent : language.tax_submit_no_consent}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center pt-4">
                        <button class="btn text-center m-1 btn-primary btn-md col-lg-3 col-md-3 col-sm-12"
                            (click)="gobackToMain()">{{language.text_close}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div id="taxError" class="modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header" style="background-color: rgb(57, 94, 119);" >
                <h5 class="modal-title" style="color: white;">แจ้งเตือน</h5>
                <button type="button" class="close" style="color: white;" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>{{taxErrorMSG}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn" style="background-color: #ffa425;" ba data-dismiss="modal"><span style="color: white;">Close</span></button>
            </div>
        </div>
    </div>
</div>